export default __webpack_public_path__ + "static/media/upload.e6f071c6.svg";